import { Vue } from 'vue-property-decorator'
import { AxiosInstance } from 'axios'

export enum AlertType {
  INFO = 'info',
  ERROR = 'error',
  WARNING = 'warning',
  SUCCESS = 'success'
}

export interface Alert {
  type: AlertType;
  message: string;
}

export interface AlertContainer {
  alert: (type: AlertType, message: string) => void;
}

const alertService = new class AlertService {
  app?: AlertContainer

  setAppContainer (app: AlertContainer) {
    this.app = app;
  }

  alert (type: AlertType, message: string) {
    if (this.app) {
      this.app.alert(type, message);
    }
  }

  info (message: string) {
    this.alert(AlertType.INFO, message);
  }
  error (message: string) {
    this.alert(AlertType.ERROR, message);
  }
  success (message: string) {
    this.alert(AlertType.SUCCESS, message);
  }
  warning (message: string) {
    this.alert(AlertType.WARNING, message);
  }

  setupInterceptors (ax: AxiosInstance) {
    ax.interceptors.response.use(res => res, err => {
      if (err && err.config &&
        err.config.url === '/clients' &&
        err.config.method === 'get' &&
        err.response && err.response.status === 401) {
        return;
      }
      this.error((err && err.response && err.response.data && err.response.data.detail) || err);
      throw err;
    })
  }
}

export default alertService;
